"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.primitives = void 0;
/*
Copyright (c) 2018-2019 Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
// color constants

var primitives = {
  primary50: '#EDF3FE',
  primary100: '#D2E0FC',
  primary200: '#9CBCF8',
  primary300: '#548BF4',
  primary400: '#276EF1',
  primary500: '#174EB6',
  primary600: '#123D90',
  primary700: '#0C2960',
  negative50: '#FDF0EF',
  negative100: '#FADBD7',
  negative200: '#F4AFA7',
  negative300: '#EB7567',
  negative400: '#E54937',
  negative500: '#AE372A',
  negative600: '#892C21',
  negative700: '#5C1D16',
  warning50: '#FEF3EC',
  warning100: '#FBE2CF',
  warning200: '#F6BA8B',
  warning300: '#F19248',
  warning400: '#ED6F0E',
  warning500: '#B4540B',
  warning600: '#8E4308',
  warning700: '#5F2C06',
  positive50: '#EBF8F2',
  positive100: '#CDEDDE',
  positive200: '#88D3B0',
  positive300: '#43B982',
  positive400: '#07A35A',
  positive500: '#057C44',
  positive600: '#046236',
  positive700: '#034124',
  mono100: '#CCCCCC',
  mono200: '#999999',
  mono300: '#7A7A7A',
  mono400: '#5C5C5C',
  mono500: '#3D3D3D',
  mono600: '#292929',
  mono700: '#1F1F1F',
  mono800: '#141414',
  mono900: '#111111',
  mono1000: '#000000',
  rating200: '#FFE1A5',
  rating400: '#FFC043',
  primaryFontFamily: 'system-ui, "Helvetica Neue", Helvetica, Arial, sans-serif'
};
exports.primitives = primitives;